<template>
    <v-card class="mx-auto" shaped elevation="7" min-height="700px">
        <v-card-title>
            Informe De Inspección
            <ModalFotoInspeccionComponent :load="load" :listFotos="_.get(listGeneral,'listFoto',[])" :obModal="obModal" />
        </v-card-title>
        <v-card-text>
            <v-container fluid grid-list-md>
                <v-row dense>
                    <v-col cols="12" sm="4">
                        <v-dialog ref="dialogFechaDesde" v-model="objDate.desde.abrirModal"
                            :return-value.sync="objSearch.fechaDesde" persistent width="340px">
                            <template v-slot:activator="{ on }">
                                <v-text-field color="textbox" v-model="objSearch.fechaDesde" label="Fecha Desde *"
                                    prepend-inner-icon="event" readonly outlined dense v-on="on" />
                            </template>
                            <v-date-picker color="primary" v-model="objSearch.fechaDesde" scrollable locale="es">
                                <v-spacer></v-spacer>
                                <v-btn outlined dense rounded color="danger" @click="objDate.desde.abrirModal = false"
                                    v-html="'Salir'"></v-btn>
                                <v-btn rounded dark color="primary"
                                    @click="$refs.dialogFechaDesde.save(objSearch.fechaDesde);"
                                    v-html="'Guardar Fecha'"></v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-dialog ref="dialogFechaHasta" v-model="objDate.hasta.abrirModal"
                            :return-value.sync="objSearch.fechaHasta" persistent width="340px">
                            <template v-slot:activator="{ on }">
                                <v-text-field color="textbox" v-model="objSearch.fechaHasta" label="Fecha Hasta *"
                                    prepend-inner-icon="event" readonly outlined dense v-on="on" />
                            </template>
                            <v-date-picker color="primary" v-model="objSearch.fechaHasta" scrollable locale="es">
                                <v-spacer></v-spacer>
                                <v-btn outlined dense rounded color="danger" @click="objDate.hasta.abrirModal = false"
                                    v-html="'Salir'"></v-btn>
                                <v-btn rounded dark color="primary"
                                    @click="$refs.dialogFechaHasta.save(objSearch.fechaHasta);"
                                    v-html="'Guardar Fecha'"></v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-col>
                    <v-col cols="12" sm="4" v-if="_.size(_.get(listGeneral,'listAseguradora',[])) > 1">
                        <v-autocomplete dense label="Aseguradora " color="textbox" v-model="objSearch.idAseguradora"
                            :items="listGeneral.listAseguradora" item-text="aseguradora" item-value="id_aseguradora"
                            outlined @change="onListarPoliza"></v-autocomplete>
                    </v-col>
                <!-- </v-row>
                <v-row dense> -->
                    <v-col cols="12" sm="4">
                        <v-autocomplete dense label="Póliza " color="textbox" v-model="objSearch.idPoliza"
                            :items="listGeneral.listPoliza" item-text="poliza" item-value="id_poliza"
                            outlined></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="3">
                        <v-text-field label="N° Certificado" color="textbox" v-model="objSearch.idCertificado" outlined dense/>
                    </v-col>
                    <v-col cols="12" sm="3">
                        <v-tooltip right color="primary">
                            <template v-slot:activator="{ on }">
                                <v-btn class="text-right mt-1" outlined color="primary" @click="onListarInpeccion"
                                    v-on="on" :disabled="disabled">
                                    Buscar<v-icon>search</v-icon>
                                </v-btn>
                            </template>
                            <span>Buscar</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col v-if="_.size(listGeneral.detalle) == 0" cols="12" sm="6"></v-col>
                    <v-col v-else cols="12" sm="6">
                        <v-btn rounded color="primary" dark @click="exportar('tableInfo','Informe de Inspección')">Exportar a XLSX</v-btn>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field label="Buscar" color="textbox" v-model="objSearch.search" clearable dense
                            prepend-inner-icon="search" />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12">
                        <v-data-table :search="objSearch.search" :headers="listGeneral.cabecera" id="tableInfo"
                            :items="listGeneral.detalle" class="elevation-3">

                            <template v-slot:item.name="{ item }">
                                <v-btn class="ma-2" text icon color="primary" @click="ver(item)">
                                    <v-icon small>visibility</v-icon>
                                </v-btn>
                            </template>

                            <template v-slot:no-results>
                                Tu búsqueda de "<span v-html="objSearch.search"></span>" no arrojó resultados.
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        components: {
            ModalFotoInspeccionComponent: () => import('@/components/utilites/ModalFotoInspeccionComponent.vue')
        },
        data: () => ({
             objDate: {
                desde: { abrirModal: false },
                hasta: { abrirModal: false }
            },
            objSearch: {
                opcion: 'LISTAR',
                search: '',
                fechaDesde: moment('2019-05-01').format('YYYY-MM-DD'),
                fechaHasta: moment().format('YYYY-MM-DD'),
                idAseguradora:null,
                idPoliza:null,
                idCertificado:null,
                idEstado:null
            },
            load:false,
            listGeneral:{},
            parametro:{},
            obModal:{}
        }),
        created(){
            var error = 'E';

            axios.post(`${BASE_URI}administrador/informe-inspeccion/cargaGeneral`)
                 .then((r)=>{
                    if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                    if(_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }
                        this.$set(this,'listGeneral',r.data.data.listas);
                        this.$set(this,'parametro',r.data.data.parametro);
                        this.objSearch.idAseguradora = this.listGeneral.listAseguradora[0].id_aseguradora;
                        this.objSearch.idEstado = this.parametro.id_estado_default;
                            
                            return this.onListarPoliza('L');
                 })
                 .catch((e) => { 
                    mensajesAlerta(e,error) 
                 });
        },
        computed:{
            disabled(){
                return _.isNull(this.objSearch.idPoliza) ? true : false;
            }
        },
        methods:{
            onListarPoliza(event){
                if(!_.isUndefined(event)){
                    var objeto = {
                        opcion: 'LISTAR',
                        idAseguradora: this.objSearch.idAseguradora
                    };

                    var error = 'E';
                    this.listGeneral.listPoliza = [];
                    this.listGeneral.detalle = [];
                    this.objSearch.idPoliza = null;

                    axios.post(`${BASE_URI}administrador/poliza/listar`,objeto)
                         .then((r)=>{
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }
                                this.listGeneral.listPoliza = r.data.data;
                         })
                         .catch((e) => { 
                            mensajesAlerta(e,error) 
                        });
                }
            },  
            onListarInpeccion(event){
                var error = 'E';
                if(!_.isUndefined(event) && !this.disabled){
                    this.listGeneral.detalle = [];

                    axios.post(`${BASE_URI}administrador/informe-inspeccion/listar`,_.omit(this.objSearch,'search'))
                         .then((r)=>{
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }
                                this.listGeneral.detalle = r.data.data;
                         })
                         .catch((e) => { 
                            mensajesAlerta(e,error) 
                        });
                }
            },
            ver(objeto){
                var error = 'E';
                axios.post(`${BASE_URI}administrador/foto-inspeccion/listar`,{ opcion:'L', idOrdenInspeccion:objeto.idOrdenInspeccion  })
                     .then((r) =>{
                        if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                        if(_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }
                            this.listGeneral.listFoto = r.data.data;
                            this.$set(this,'obModal',objeto);
                            this.load = true;
                     })
            },
            close(){
                this.load = false;
                this.listGeneral.listFoto = [];
                this.obModal = {};
            }
        },
        provide(){
            return{
                close: this.close
            }
        }
    }
</script>